import {Component, Inject, OnInit} from '@angular/core';
@Component({
  selector: 'aspr-footer',
  templateUrl: './aspr-footer.component.html',
  styleUrls: ['./aspr-footer.component.scss']
})

export class AsprFooterComponent implements OnInit {
  iconBase: string = "";

  constructor(
    @Inject('BASE_URL') public baseUrl: string,
    @Inject('AGENCY_LOGO') public agencyLogo: string,
    @Inject('DEPARTMENT_LOGO') public departmentLogo: string,
    @Inject('DEPARTMENT') public department: string,
    @Inject('HELP_ISSUE') public helpIssue: string,
    @Inject('HELP_LINK') public helpLink: string,
    @Inject('HELP_EMAIL') public helpEmail: string,
    @Inject('VULNERABILITY_POLICY') public vulnerabilityPolicy: string,
    @Inject('HELP_NUMBER') public helpNumber: string) {
      this.iconBase = this.baseUrl;
    }

  ngOnInit() { }
}
